import { AccessRoleEnum } from 'src/enums';

export const rolesId = [
  { value: 1, label: 'Administrator' },
  { value: 2, label: 'Manager' },
  { value: 4, label: 'Customer Service' },
  { value: 3, label: 'APIKEY' },
];

export const roles = ['Administrator', 'Manager', 'Customer Service', 'APIKEY'];

export const rolesToModuleAccess = [
  AccessRoleEnum.ADMINSTRATOR,
  AccessRoleEnum.MANAGER,
  AccessRoleEnum.CUSTOMER_SERVICE,
];

export const rolesPermissions = [
  {
    role: AccessRoleEnum.ADMINSTRATOR,
    canRead: true,
    canWrite: true,
  },
  {
    role: AccessRoleEnum.MANAGER,
    canRead: true,
    canWrite: true,
  },
  {
    role: AccessRoleEnum.CUSTOMER_SERVICE,
    canRead: true,
    canWrite: false,
  },
  {
    role: AccessRoleEnum.APIKEY,
    canRead: false,
    canWrite: false,
  },
];

export function getPermissionsByRole(role: AccessRoleEnum) {
  return rolesPermissions.find((r) => r.role === role) || { canRead: false, canWrite: false };
}
